import { rootId } from "../../common/constants/root-id";

export const readPageVisibleText = () => {
  const { body } = document;
  const copy = body.cloneNode(true) as HTMLElement;
  
  const excludedElements = copy.querySelectorAll(`style, script, #${rootId}`);

  excludedElements.forEach((element) => element.remove());

  return copy.innerText;
};